module.exports = __webpack_public_path__ + "static/ergul-web-058d35af40752106e9d5b8357698fbed.jpg";